import React, { useState } from 'react'
import { Form, message, Input } from 'antd';
import { Link } from 'react-router-dom';
import AuthLayout from './authLayout';
import BlueButton from '../../components/shared/BlueButton';
import { registerUser } from '../../api/auth';

export default function UserRegistration() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await registerUser({ email: values.email });
            if (res.Code === 1) {
                message.success("Verification link sent to your email.");
            } else {
                message.error(res.Data.message);
            }
        } catch (err) {
            message.error("Something went wrong, please try again later");
        }
        setLoading(false)
    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    return (
        <AuthLayout>
            <section>
                <Form form={form} layout='vertical' onFinish={onFinish}
                    onFinishFailed={onFinishFailed}>
                    <Form.Item name="email" label="Email" rules={[{ required: true }]} ><Input type='email' className='rounded-none' /></Form.Item>
                    <Form.Item className='flex justify-center'>
                        <BlueButton type="primary" className="rounded-none min-w-[66.5px]" htmlType="submit" disabled={loading}>Register</BlueButton>
                    </Form.Item>
                </Form>
            </section>

            <p className='text-center text-[#A0A0A0]'>Already have an account? <Link to="/login">Sign In</Link></p>

        </AuthLayout>
    )
}
